module.exports = __webpack_public_path__ + "img/img_1.f09cc6f4.png";